import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedService } from './shared.service';

@Injectable()
export class RegistrationService {
  

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) {}

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log error to console
      // Let the app keep running by returning an empty result.
      return of(error as T);
    };
  }

  public registerClient(clientDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/customer/register', clientDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any>('registerClient', {error: ''}))
    );
  }

  public receiveOTP(userID: string): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'session/receive/otp/' + userID, this.jsonOptions).pipe(
      catchError(this.handleError<any>('registerClient', {error: ''}))
    );
  }

  public getUser(userID: string): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'session/receive/forgot-otp/' + userID, this.jsonOptions).pipe(
      catchError(this.handleError<any>('registerClient', {error: ''}))
    );
  }

  public checkOTP(OTPDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/confirm/otp', OTPDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any>('registerClient', {error: ''}))
    );
  }

  public resendOTP(userID: string): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/reset/password/resend-otp/'+ userID, this.jsonOptions).pipe(
      catchError(this.handleError<any>('registerClient', {error: ''}))
    );
  }

  public importUserRegister(clientDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/import/customer/register', clientDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any>('registerImportClient', {error: ''}))
    );
  }

  public importUserInvite(clientDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/import/customer/invite', clientDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any>('inviteImportClient', {error: ''}))
    );
  }

  public resendOtp(userId: string) {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/customer/resend-activation/'+ userId, this.jsonOptions).pipe(
      catchError(this.handleError<any>('inviteImportClient', {error: ''}))
    );
  }

  
  public registerDriver(clientDetails: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'session/register/driver', clientDetails, this.jsonOptions).pipe(
      catchError(this.handleError<any>('registerClient', {error: ''}))
    );
  }
}
